// extracted by mini-css-extract-plugin
export default {"gridList":"LeadList_gridList__hLKYp"};